import createIcon from '../../createIcon';

/**
 * @component @name TextSnippet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNDEgOC40MUwxNS41OCAzLjU4QzE1LjIxIDMuMjEgMTQuNyAzIDE0LjE3IDNINUMzLjkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY5LjgzQzIxIDkuMyAyMC43OSA4Ljc5IDIwLjQxIDguNDFaTTcgN0gxNFY5SDdWN1pNMTcgMTdIN1YxNUgxN1YxN1pNMTcgMTNIN1YxMUgxN1YxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextSnippet = createIcon('TextSnippet', [
  [
    'path',
    {
      d: 'M20.41 8.41L15.58 3.58C15.21 3.21 14.7 3 14.17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V9.83C21 9.3 20.79 8.79 20.41 8.41ZM7 7H14V9H7V7ZM17 17H7V15H17V17ZM17 13H7V11H17V13Z',
      key: '1wwa6x',
    },
  ],
]);

export default TextSnippet;
